"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MozartSavingsStorageV1Factory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MozartSavingsStorageV1Factory = /** @class */ (function (_super) {
    __extends(MozartSavingsStorageV1Factory, _super);
    function MozartSavingsStorageV1Factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MozartSavingsStorageV1Factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MozartSavingsStorageV1Factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MozartSavingsStorageV1Factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MozartSavingsStorageV1Factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MozartSavingsStorageV1Factory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MozartSavingsStorageV1Factory;
}(contracts_1.ContractFactory));
exports.MozartSavingsStorageV1Factory = MozartSavingsStorageV1Factory;
var _abi = [
    {
        constant: true,
        inputs: [],
        name: "arcFee",
        outputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "indexLastUpdate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "savingsIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "savingsRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "synthetic",
        outputs: [
            {
                internalType: "contract ISyntheticToken",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupplied",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b506101e0806100206000396000f3fe608060405234801561001057600080fd5b506004361061007d5760003560e01c80636ecd067f1161005b5780636ecd067f146100bd578063afe1f9a4146100c5578063beb2cbe3146100da578063d92af3b2146100e25761007d565b806317dd9406146100825780635c975abb146100a0578063630fd0ac146100b5575b600080fd5b61008a6100ea565b604051610097919061016a565b60405180910390f35b6100a86100f0565b6040516100979190610148565b61008a610100565b61008a610106565b6100cd61010c565b604051610097919061015c565b61008a61011b565b61008a610121565b60045481565b600354600160a01b900460ff1681565b60075481565b60055481565b6003546001600160a01b031681565b60065481565b60085481565b61013081610178565b82525050565b6101308161018c565b61013081610189565b602081016101568284610127565b92915050565b602081016101568284610136565b60208101610156828461013f565b151590565b6001600160a01b031690565b90565b60006101568260006101568261017d56fea365627a7a723158205a846c3f772cc60ff01db4ef50df2f673462055dd30f87c53363b63f3442c4da6c6578706572696d656e74616cf564736f6c63430005100040";
//# sourceMappingURL=MozartSavingsStorageV1Factory.js.map